import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './MapBadges.css';

const MapBadges = ({ 
    onBadgeSelect, 
    selectedBadges = [], 
    availableBadges = [], 
    onBadgeDragStart,
    showInstructions = true,
    enableToggle = false,
    onToggleInstructions
}) => {
    const { t } = useTranslation();
    // If no available badges are provided, don't show the component
    if (availableBadges.length === 0) {
        return null;
    }

    const handleBadgeClick = (badge) => {
        onBadgeSelect(badge);
    };

    const handleDragStart = (e, badge) => {
        // Store badge data for the drop
        e.dataTransfer.setData('badge', JSON.stringify(badge));
        e.dataTransfer.effectAllowed = 'copy';
        
        // Create a ghost image
        const dragImage = e.target.cloneNode(true);
        dragImage.style.width = '60px';
        dragImage.style.height = '60px';
        document.body.appendChild(dragImage);
        e.dataTransfer.setDragImage(dragImage, 30, 30);
        setTimeout(() => document.body.removeChild(dragImage), 0);
        
        if (onBadgeDragStart) {
            onBadgeDragStart(badge);
        }
    };

    return (
        <div className="map-badges-container">
            <h3>{t('badges.congrats', 'Congrats you have unlocked new badges')}</h3>
            <div className="badges-list">
                {availableBadges.map(badge => (
                    <div
                        key={badge.id}
                        className={`badge-item ${selectedBadges.some(b => b.id === badge.id) ? 'selected' : ''}`}
                        onClick={() => handleBadgeClick(badge)}
                        onDragStart={(e) => handleDragStart(e, badge)}
                        draggable={true}
                        title={badge.name}
                    >
                        <img 
                            src={badge.imageUrl} 
                            alt={badge.name}
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </div>
                ))}
            </div>
            {enableToggle && !showInstructions ? (
                <button 
                    type="button" 
                    className="badge-help-toggle"
                    onClick={onToggleInstructions}
                >
                    {t('badges.howToUse', 'How to use badges')}
                </button>
            ) : (
                <ul className="map-badges-instructions" style={{ display: 'inline-block', textAlign: 'left' }}>
                    <li>{t('badges.instrAdd')}</li>
                    <li>{t('badges.instrResize')}</li>
                    <li>
                        <Link to="/badges">
                            {t('badges.instrCollectionSentence', 'Create more maps to complete your collection')}
                        </Link>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default MapBadges;